import React from "react";
import { string, object } from "prop-types";
import "./subtitle.m.css";

export const Subtitle = ({ children, style }) => {
  return (
    <div styleName="subtitle" style={style}>
      {children}
    </div>
  );
};

Subtitle.propTypes = {
  children: string.isRequired,
  style: object,
};